















import { defineComponent } from "@vue/composition-api";
import BaseIcon from "@/components/BaseIcon";

export default defineComponent({
  name: "AudioAttachmentPlayerView",
  components: { BaseIcon },
  props: {
    formattedRemainingTime: { type: String, default: 0 },
    isAudioPlaying: { type: Boolean, default: 0 },
  },
});
